import BaseWizardContent from './themes/BaseWizardContentLight.css';
import SidebarItem from './components/Sidebars/components/themes/SidebarItemLight.css';
import SidebarNumberedItem from './components/Sidebars/components/themes/SidebarNumberedItemLight.css';
import SidebarHeader from './components/Sidebars/components/themes/SidebarHeaderLight.css';
import SidebarSummary from './components/Sidebars/components/themes/SideBarSummaryLight.css';
import PageHeader from './components/themes/PageHeaderLight.css';
import PageFooter from './components/themes/PageFooterLight.css';
import CancelModal from './components/themes/CancelModalLight.css';

export default {
  BaseWizardContent,
  SidebarItem,
  SidebarNumberedItem,
  SidebarHeader,
  SidebarSummary,
  PageHeader,
  PageFooter,
  CancelModal
};
